// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1qgzK","productName":"Table_productName__265kd"};